const SettingToggle = ({text, checked, onChange, storage}) => {
  const changeSetting = () => {
    onChange(prev => !prev)
    localStorage.setItem(storage, !checked)
  }

  return (
    <label className="setting-toggle">
      <span>{text}</span>
      <input
        onChange={changeSetting}
        checked={checked}
        type="checkbox"
        role="switch"
        aria-label={text}
      />
      <span className="setting-toggle-control" aria-hidden="true"/>
    </label>
  );
};

export default SettingToggle;
